import * as Mui from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { useTheme } from '../../ThemeContext';
import { defaultCurrency } from '../../configs/constant';
import { InputField } from '../form';
import { useEffect, useRef } from 'react';

export const ProductPriceLayout = ({ title, subtitle, trailing, unit, productPrices = [], inclVATComp, exclVATComp, vatComp, accountNumberComp, vatCodeComp, vatRateComp, activeComp, listBackground }) => {

    const { t } = useTranslation()
    const { theme } = useTheme()
    return <Mui.Box>
        <Mui.Box display={'flex'} alignItems={'center'} justifyContent={'space-between'}>
            <Mui.Box>
                <Mui.Typography
                    component="span"
                    variant="body1"
                    className=" mb-2 font-weight-medium"
                    style={{
                        color: "rgba(99, 99, 107, 0.5)",
                        fontSize: '1.6rem',
                        letterSpacing: '0.8px'
                    }}
                >
                    {title}
                </Mui.Typography>
                <br />
                <Mui.Typography
                    component="span"
                    variant="body1"
                    className=" mb-2 font-weight-regular"
                    style={{
                        color: "rgba(154, 161, 167, 0.7)",
                        fontSize: '1.3rem',
                        letterSpacing: '0.8px'
                    }}
                >
                    {subtitle}
                </Mui.Typography>
            </Mui.Box>
            <Mui.Box>
                {trailing}
            </Mui.Box>
        </Mui.Box>

        <Mui.Box style={{ border: `1px solid ${theme === 'dark' ? '#ffffff15' : '#00000015'}`, borderRadius: '0.5rem', padding: '0rem 2rem 2rem 2rem' }}>
            <Mui.Grid container spacing={2} alignItems="center" className="mt-2" style={{ padding: `0rem ${listBackground ? '1' : '0'}rem` }}>
                <Mui.Grid item sm={3}>
                    <Mui.Typography component={'h6'}>{t("PRODUCT.FORM.PRICE_INCL_VAT")} {unit}</Mui.Typography>
                </Mui.Grid>
                <Mui.Grid item sm={2}>
                    <Mui.Typography component={'h6'} className="text-center">{t("PRODUCT.FORM.PRICE_EXCL_VAT")} {unit}</Mui.Typography>
                </Mui.Grid>
                <Mui.Grid item sm={2}>
                    <Mui.Typography component={'h6'} className="text-center">{t("ORDER.TABLE.VAT")}</Mui.Typography>
                </Mui.Grid>
                <Mui.Grid item sm={2}>
                    <Mui.Typography component={'h6'} className="text-center">{t("PRODUCT_CATEGORY.ACCOUNT_NUMBER")}</Mui.Typography>
                </Mui.Grid>
                <Mui.Grid item sm={1}>
                    <Mui.Typography component={'h6'} className="text-center">{t("PRODUCT.FORM.VAT_CODE")}</Mui.Typography>
                </Mui.Grid>
                <Mui.Grid item sm={1}>
                    <Mui.Typography component={'h6'} className="text-center">{t("PRODUCT.FORM.VAT_RATE")}</Mui.Typography>
                </Mui.Grid>
                <Mui.Grid item sm={1}>
                    <Mui.Typography component={'h6'}>{t("PRODUCT.FORM.ACTIVE")}</Mui.Typography>
                </Mui.Grid>
            </Mui.Grid>
            {productPrices.map((price, index) => {
                return <Mui.Box key={index} style={{ borderRadius: '0.5rem', padding: `1rem ${listBackground ? '1' : '0'}rem`, marginBlock: '1rem', background: listBackground ? '#00000010' : 'transparent' }}>
                    <Mui.Grid container spacing={2} alignItems="center">
                        <Mui.Grid item sm={3} className="form-group mt-0 mb-0">
                            {inclVATComp(price, index)}
                        </Mui.Grid>
                        <Mui.Grid item sm={2} className="form-group mt-0 mb-0">
                            {exclVATComp(price, index)}
                        </Mui.Grid>
                        <Mui.Grid item sm={2} className="form-group mt-0 mb-0">
                            {vatComp((+price.priceIncludingVat - +price.priceExcludingVat).toFixed(2), index)}
                        </Mui.Grid>
                        <Mui.Grid item sm={2}>
                            {accountNumberComp(price, index)}
                        </Mui.Grid>
                        <Mui.Grid item sm={1}>
                            {vatCodeComp(price, index)}
                        </Mui.Grid>
                        <Mui.Grid item sm={1}>
                            {vatRateComp(price, index)}
                        </Mui.Grid>
                        <Mui.Grid item sm={1}>
                            {activeComp(price, index)}
                        </Mui.Grid>
                    </Mui.Grid>
                </Mui.Box>
            })}
        </Mui.Box>

    </Mui.Box>
}

export const PriceInputField = ({ name, disabled, placeholder, onChange, loading = false, endAdornment = null, showEndAdornment = true, focus = false }) => {

    const inputRef = useRef();

    useEffect(() => {
        const handleWheel = (e) => {
            e.preventDefault(); // Prevent the default scroll behavior
        };

        const inputElement = inputRef.current;
        if (inputElement) {
            inputElement.addEventListener('wheel', handleWheel);
        }

        return () => {
            if (inputElement) {
                inputElement.removeEventListener('wheel', handleWheel);
            }
        };
    }, []);


    return <InputField
        loading={loading}
        name={name}
        type="number"
        disabled={disabled}
        placeholder={placeholder}
        onKeyDown={(evt) => ["e", "E", "+", "-", "ArrowUp", "ArrowDown"].includes(evt.key) && evt.preventDefault()}
        onChange={(e) => {
            const input = e.target.value;
            const decimalIndex = input.indexOf(".");
            //restrict the user to input value only to the second decimal places
            if (decimalIndex !== -1 && input.split(".")[1].length > 2) {
                e.target.value = input.substring(0, decimalIndex + 3);
            }
            onChange?.(e)
        }}
        style={focus ? { border: '1px solid #e0b002', borderRadius: '0.75rem' } : {}}
        InputProps={{
            endAdornment: showEndAdornment ? (
                endAdornment ??
                <Mui.InputAdornment position="end">
                    <Mui.Typography style={{ color: focus ? '#e0b002' : 'inherit' }} className="pr-1">{defaultCurrency.symbol}</Mui.Typography>
                </Mui.InputAdornment>
            ) : <></>
        }}
        inputRef={(node) => {
            inputRef.current = node
        }}
    />
}